export * from '@macs-frontend/web/core/base';
export { MdCoreModule } from '@macs-frontend/web/core/core.module';
